import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/anybill_logo.svg")